module.exports = __webpack_public_path__ + "img/AudiovisualComandoEnActivacion.1423121e.svg";